/* eslint-disable react/prop-types */
import { Drawer, Text } from "@mantine/core";

const DrawerFormComp = ({ opened, onClose, title, children, ...props }) => {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title={
        <Text fw={600} size="20px">
          {title}
        </Text>
      }
      position={"right"}
      overlayProps={{ backgroundOpacity: 0.2, blur: 2 }}
      styles={{
        header: {
          width: "100%",
        },
        title: {
          width: "100%",
        },
        close: {
          marginBottom: 20,
          alignSelf: "center", 
        },
      }}
      {...props}
    >
      {children}
    </Drawer>
  );
};

export default DrawerFormComp;
